
export const HEADER_FIRST_BUTTON_TEXT = "Startup Kit";
export const HEADER_SECOND_BUTTON_TEXT = "Contact us";

export const IMPRESSIT_LOGO_ARIA_LABEL = "Impressit logo";
export const IMPRESSIT_LOGO_ALTERNATIVE_TEXT = "Impressit logo";